module.exports = __webpack_public_path__ + "img/cn-pro-t.4d219a71.png";